module.exports = __webpack_public_path__ + "static/media/corporate.538d7a9d.svg";